import script from "./EventDetailsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventDetailsModal.vue?vue&type=script&lang=ts&setup=true"

import "./EventDetailsModal.vue?vue&type=style&index=0&id=68e99392&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e99392"]])

export default __exports__